import script from "./batch-update-no.vue?vue&type=script&lang=ts&setup=true"
export * from "./batch-update-no.vue?vue&type=script&lang=ts&setup=true"

import "./batch-update-no.vue?vue&type=style&index=0&id=255a0c85&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-255a0c85"]])

export default __exports__